
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evaluate/list",
      function () {
        return require("private-next-pages/evaluate/list/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evaluate/list"])
      });
    }
  